import { jsx, jsxs } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import clsx from 'clsx';
import { useMenuItemSurfaceProps } from './menu-v2.hooks.js';
import { ItemPrimitive } from './menu-v2.item-primitive.js';
import { item, itemIndent, itemSelectIcon, itemLead, itemText, itemTrail, itemInner, itemVariant } from './menu-v2.css.js';

/**
 * Menu.Item
 *
 * @compose { "parent": ["MenuV2.Root", "MenuV2.Group", "MenuV2.SubMenu"], "multi": true }
 */
const Item = forwardRef(({ children, lead, trail, style, variant = 'default', ...props }, ref) => {
    const activeSurfaceTreatment = variant === 'destructive' ? 'danger' : 'brand';
    const { interactionProps, paintProps } = useMenuItemSurfaceProps({
        targetId: props.targetId,
        disabled: props.disabled,
        treatment: activeSurfaceTreatment,
    });
    return (jsx(ItemPrimitive, { "data-fpl-component": "", ...interactionProps, ...props, ref: ref, className: item, style: style, children: jsx(ItemDisplay, { ...paintProps, lead: lead, trail: trail, variant: variant, children: children }) }));
});
Item.displayName = 'MenuV2.Item';
/** Internal styling for a menu item. Should probably not be used externally. */
const ItemDisplay = forwardRef(({ children, selectIcon, lead, trail, variant, ...props }, ref) => {
    return (jsxs("span", { ...props, ref: ref, className: clsx(itemInner, variant && itemVariant[variant]), children: [jsx("span", { className: itemIndent, "aria-hidden": true, children: selectIcon && jsx("span", { className: itemSelectIcon, children: selectIcon }) }), lead && jsx("span", { className: itemLead, children: lead }), jsx("span", { className: itemText, children: children }), trail && jsx("span", { className: itemTrail, children: trail })] }));
});
ItemDisplay.displayName = 'MenuV2.ItemDisplay';

export { Item, ItemDisplay };
//# sourceMappingURL=menu-v2.item.js.map
